import { createContext, useContext, useEffect, useState } from 'react';
import PageDevice from '../../page/PageDevice';
import { getRoutes } from '../../routes/getRoutes';
import { PapsContext } from './PapsContext';
import { StartContext } from './StartContext';
import { CurrentSettingsContext } from './SettingsDataContext';
import FullPageWrapper from 'global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import { RegDataContext } from './RegDataContext';
import { AppContext } from './AppProvider';
// import { useAppRoutes } from './useHelpers/useAppRoutes';

export const RoutesContext = createContext();

const RoutesProvider = (props) => {

  const appContext = useContext(AppContext)
  const { app_state } = appContext ?? {}

  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext ?? {}
  const { pathViews } = paps_state ?? {}
  const { events: eventKey } = pathViews ?? {}

  const isMobileDevice = _.get(app_state, 'currentEnvironment.platform.isMobileDevice', false)

  // startContext
  const startContext = useContext(StartContext)
  const { start_handlers } = startContext ?? {}

  // currentSettingsContext
  const currentSettingsContext = useContext(CurrentSettingsContext)
  const { currentSettings_state } = currentSettingsContext ?? {}
  const { aps_views } = _.get(currentSettings_state, 'gvviSettings', {});

  const regDataContext = useContext(RegDataContext)
  const { regData_state } = regDataContext ?? {}
  const { isRegDemo, regInfo } = regData_state ?? {}

  // const { appRoutes } = useAppRoutes({ aps_views })

  // local state
  const [viewRoutes, setViewRoutes] = useState()
  const [genericRoutes, setGenericRoutes] = useState()

  const routes_state = { viewRoutes, genericRoutes }

  const usePageTransitions = isMobileDevice ? true : false

  // useEffect(() => {
  //   if (appRoutes) {
  //     setViewRoutes(appRoutes?.viewRoutes)
  //     setGenericRoutes(appRoutes?.genericRoutes)
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [appRoutes]);

  // IMPORTANT: Page Settings- get the settings for the page
  useEffect(() => {
    if (aps_views) {
      start_handlers.handleAmmend_useEffect('RoutesProvider')
      const { viewRoutes, genericRoutes } = getRoutes(<PageDevice />, Object.keys(aps_views).sort(), usePageTransitions)
      setViewRoutes(viewRoutes)
      setGenericRoutes(genericRoutes)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aps_views]);

  const routesProvider = () => {
    return <RoutesContext.Provider value={{ routes_state }}>
      {props.children}
    </RoutesContext.Provider>
  }

  const noRoutes = () => {
    if (isRegDemo) {
      return <FullPageWrapper
        topperCaption={'Reg Demo'}
        content={<Wrapper
          header={`Fetching Reg Data for event ${eventKey}`}
          content={<div style={{ padding: '1em' }}>{'Please be patient...'}</div>}
          wrapperType={wrapperTypes.padded}
          css={{ container: 'app-dark-mode' }}
        ></Wrapper>}
      />
    } else {
      return <FullPageWrapper
        topperCaption={'Invalid Page'}
        content={<Wrapper
          header={'Page Not Found'}
          content={'No page exists for the selected page.'}
          wrapperType={wrapperTypes.padded}
          css={{ container: 'app-dark-mode' }}
        ></Wrapper>}
      />
    }
  }

  return genericRoutes ? routesProvider() : <div></div> // noRoutes()
}

export default RoutesProvider
